import { postApi } from "./api_instance";

export const bidConditions = async (projectId, dispatch) => {
  const info = { projectId: projectId, };
  try {
    const { data } = await postApi({
      apiUrl: `/projects/api/myBids/verify-bid`,
      sendToken: true,
      dispatch,
      data: info,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
